var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.438,
    height: 59.482,
    viewBox: "0 0 16.785 15.738",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91 15.582L.34 10.105a.822.822 0 01-.292-.94L3.114.545A.822.822 0 013.888 0h9.008c.348 0 .658.219.774.546l3.067 8.618a.823.823 0 01-.293.941l-7.57 5.477a.82.82 0 01-.963 0",
    fill: "#44c4fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.394 8.531h.003zm-5.658-.2l2.656 1.521 2.656-1.52V5.247l-2.656-1.52-2.656 1.52zm2.656 2.264a.343.343 0 01-.17-.046L5.22 8.831a.345.345 0 01-.174-.3V5.048c0-.124.066-.238.174-.3L8.22 3.032a.345.345 0 01.343 0l3 1.718a.345.345 0 01.175.3V8.53a.345.345 0 01-.174.3l-3.001 1.718a.346.346 0 01-.172.046",
    fill: "#008fb9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.174 4.97l-.782-.448-1.966 1.126v2.284l1.404.803z",
    fill: "#fdfeff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.594 9.395L5.736 8.331V5.248l2.656-1.52 1.018.582.236-.66-1.082-.62a.345.345 0 00-.343 0L5.22 4.75a.345.345 0 00-.174.3v3.483c0 .123.066.237.174.299l2.139 1.225z",
    fill: "#fdfeff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.072 9.4l-1.129-3.173-2.499 1.92v.384c0 .376-.202.725-.528.912L8.914 11.16a1.05 1.05 0 01-1.043 0l-1.264-.723H2.004l6.32 4.572a.117.117 0 00.136 0l7.57-5.476c.042-.03.06-.085.042-.133",
    fill: "#008fb9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.669 1.39h8.552l-.215-.607a.116.116 0 00-.11-.077H3.888a.116.116 0 00-.11.077L.713 9.4a.117.117 0 00.042.134l.818.592z",
    fill: "#fdfeff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon-diamond.fc530f96f3892477e5920fb16b375684.svg";
export { ForwardRef as ReactComponent };